import { Avatar, AvatarFallback, AvatarImage } from '../../ui/avatar';
import { entryByline } from '../../../lib/entries';

const initials = (s) => {
  const v = (s || '').trim();
  if (!v) return '?';
  const parts = v.split(/[\s._-]+/).filter(Boolean);
  return (parts.length >= 2 ? parts[0][0] + parts[1][0] : parts[0].slice(0, 2)).toUpperCase();
};

const PlayersTab = ({ players }) => {
  if (!players || players.length === 0) {
    return (
      <div className="border border-dashed border-border/60 px-6 py-12 text-center text-sm text-muted-foreground">
        No players registered yet.
      </div>
    );
  }

  return (
    <ul className="divide-y divide-border/60 border-y border-border/60">
      {players.map((player, i) => (
        <li
          key={player.id}
          className="grid grid-cols-[auto_auto_1fr_auto] items-center gap-4 px-2 py-3"
        >
          <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground tabular-nums">
            {String(i + 1).padStart(2, '0')}
          </span>
          <Avatar className="h-8 w-8">
            {player.imageUrl && <AvatarImage src={player.imageUrl} alt="" />}
            <AvatarFallback>{initials(player.name)}</AvatarFallback>
          </Avatar>
          <div className="min-w-0">
            <div className="truncate font-display text-base font-medium">{player.name}</div>
            {entryByline(player) && (
              <div className="truncate text-xs text-muted-foreground">by {entryByline(player)}</div>
            )}
          </div>
          <div className="flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-muted-foreground">
            {player.country && (
              <img
                src={`https://flagcdn.com/24x18/${player.country.toLowerCase()}.png`}
                alt=""
                className="h-[14px] w-[18px] rounded-[2px] object-cover"
              />
            )}
            <span className="hidden sm:inline">{player.countryName || player.country || '—'}</span>
          </div>
        </li>
      ))}
    </ul>
  );
};

export default PlayersTab;
